const KEY = "am_ref";
const DAYS = 60;

export const saveRef = (code) => {
  const exp = new Date(Date.now() + DAYS * 864e5);
  localStorage.setItem(KEY, JSON.stringify({ code, exp: exp.toISOString() }));
  document.cookie = `${KEY}=${encodeURIComponent(code)}; expires=${exp.toUTCString()}; path=/; SameSite=Lax`;
};

export const getRef = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && new Date(v.exp) > new Date()) return v.code;
  } catch { /* ignore */ }
  const m = document.cookie.match(/(?:^|; )am_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};

export const visitorId = () => {
  let id = localStorage.getItem("am_vid");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`).replace(/[^a-z0-9-]/gi, "");
    localStorage.setItem("am_vid", id);
  }
  return id;
};
